import { Col, Row } from 'antd';
import { format } from 'date-fns';

import { convertESTToLocalTime } from '@/utilz';
import Paper from '@/views/components/Paper/Paper';
import TMSFiledCard from '@/views/screens/common/components/TMSFiledCard';

const LADEmailStatusCard = ({ data }) => {
  return (
    <Paper className="mb-15 p-10" border>
      <Row gutter={10}>
        <Col sm={2}>
          <TMSFiledCard title="Claim Key">{data.claimKey}</TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Senders Email">{data.sendersEmail}</TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Recipient">{data.recipient}</TMSFiledCard>
        </Col>
        <Col sm={3}>
          <TMSFiledCard title="Sent On">
            {data.sentOn ? format(convertESTToLocalTime(data.sentOn), 'MM/dd/yyyy HH:mm:ss a') : ''}
          </TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Email Subject">{data.emailSubject}</TMSFiledCard>
        </Col>
        <Col sm={2}>
          <TMSFiledCard title="Status Desc">{data.statusDesc}</TMSFiledCard>
        </Col>
        <Col sm={2}>
          <TMSFiledCard title="Description">{data.description}</TMSFiledCard>
        </Col>
        <Col sm={3}>
          <TMSFiledCard title="Date Time Of Action">
            {data.dateTimeOfAction ? format(convertESTToLocalTime(data.dateTimeOfAction), 'MM/dd/yyyy HH:mm:ss a') : ''}
          </TMSFiledCard>
        </Col>
      </Row>
    </Paper>
  );
};

export default LADEmailStatusCard;
